import { render, staticRenderFns } from "./vas-response.vue?vue&type=template&id=1077fc39&scoped=true&"
import script from "./vas-response.vue?vue&type=script&lang=js&"
export * from "./vas-response.vue?vue&type=script&lang=js&"
import style0 from "./vas-response.vue?vue&type=style&index=0&id=1077fc39&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1077fc39",
  null
  
)

component.options.__file = "vas-response.vue"
export default component.exports